<template>
	<Input v-if="cellEditing || cellEditable"
	    v-bind="$attrs"
	    v-on="editEvents"
	    :value="value"
        :readonly="!cellEditing || $attrs.readonly"
	    :inputStyle="inputStyle"
	    @input="onChange">
	</Input>
	<cell-render v-else-if="render"
	    :render="render"
	    :context="$props"></cell-render>
	<div v-else :class="prefixCls + '-wrap-readonly'"
		data-cls="cell-content">
		<slot>
			<span>{{ value }}</span>
		</slot>
	</div>
</template>
<script>
import mixin from './mixin'
import Input from '../input'

export default {
	mixins: [mixin],

	components: {
		Input
	},

	name: "CellInput",

	computed: {
		inputStyle() {
			return {
				textAlign: this.align
			}
		}
	}
}
</script>